import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";
import { SetOOSEstimatedDeliveryDateParams } from "../types/SetOOSEstimatedDeliveryDateParams";

export const useSetOOSEstimatedDeliveryDateParams = (params: SetOOSEstimatedDeliveryDateParams) => {
    const { mutate, isLoading } = useMutation({
        mutationFn: async (params: SetOOSEstimatedDeliveryDateParams) => {
            return await apiClient.post("purchase-order/set-oos-estimated-delivery-date", {
                OutOfStocks: params.OutOfStocks
            }) as ApiResult;
        },
        onSuccess: async (result) => {
            if (result.isSuccess) {
                params.onSuccess();
            } else {
                params.onError('Error when submitting estimated delivery date: ' + result.errorMessage!);
            }
        },
        onError: (error) => {
            params.onError(error as string);
        }
    });

    return {
        mutate,
        isLoading
    };
};
